import { render, staticRenderFns } from "./myInvestor_ok.vue?vue&type=template&id=cdd09780&scoped=true"
import script from "./myInvestor_ok.vue?vue&type=script&lang=js"
export * from "./myInvestor_ok.vue?vue&type=script&lang=js"
import style0 from "./myInvestor_ok.vue?vue&type=style&index=0&id=cdd09780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd09780",
  null
  
)

export default component.exports